var map = {
	"./module/administrador/administrador.module": [
		"./src/app/module/administrador/administrador.module.ts",
		"default~module-administrador-administrador-module~module-peticiones-peticiones-module~module-transac~7ae88d8d",
		"default~module-administrador-administrador-module~module-peticiones-peticiones-module~module-usuario~674710f2",
		"module-administrador-administrador-module"
	],
	"./module/auth/auth.module": [
		"./src/app/module/auth/auth.module.ts",
		"default~module-auth-auth-module~module-usuario-usuario-module",
		"module-auth-auth-module"
	],
	"./module/peticiones/peticiones.module": [
		"./src/app/module/peticiones/peticiones.module.ts",
		"default~module-administrador-administrador-module~module-peticiones-peticiones-module~module-transac~7ae88d8d",
		"default~module-administrador-administrador-module~module-peticiones-peticiones-module~module-usuario~674710f2",
		"module-peticiones-peticiones-module"
	],
	"./module/transacciones/transacciones.module": [
		"./src/app/module/transacciones/transacciones.module.ts",
		"default~module-administrador-administrador-module~module-peticiones-peticiones-module~module-transac~7ae88d8d",
		"default~module-transacciones-transacciones-module~module-usuario-usuario-module",
		"module-transacciones-transacciones-module"
	],
	"./module/usuario/usuario.module": [
		"./src/app/module/usuario/usuario.module.ts",
		"default~module-administrador-administrador-module~module-peticiones-peticiones-module~module-transac~7ae88d8d",
		"default~module-administrador-administrador-module~module-peticiones-peticiones-module~module-usuario~674710f2",
		"default~module-auth-auth-module~module-usuario-usuario-module",
		"default~module-transacciones-transacciones-module~module-usuario-usuario-module",
		"module-usuario-usuario-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;